import React from 'react';
import { observer } from 'mobx-react';
import {
  InfoBlockContainer,
  MainInfo,
  Name,
  TimeSpan,
  SecondaryInfo,
  SecondaryInfoBlock,
  Label,
  Container,
} from './styles/_infoBlock';
import view from 'modules/ticketPublicPage/stores/tickets/view';
import form from 'modules/ticketPublicPage/stores/tickets/form';
import Header from './common/Header';
import { InfoText } from './common/Common.styles';
import NoTicketsInfo from './common/NoTicketsInfo';

const InfoBlock = observer(() => {
  const {
    name,
    description,
    conditions,
    has_expired: hasExpired,
    status,
    tickets_remained: ticketsRemained,
    min_purchases: minPurchases,
  } = view.activeObject;
  const { timespan } = view;
  const { step, INITIAL } = form;
  const hasAvailableTickets =
    status === 'active' &&
    view.available &&
    !hasExpired &&
    ticketsRemained >= minPurchases;
  return (
    <Container>
      <InfoBlockContainer>
        <Header
          style={{ visibility: !hasAvailableTickets ? 'hidden' : 'initial' }}
        />
        <MainInfo>
          <Name>{name}</Name>
          <TimeSpan>{timespan}</TimeSpan>
        </MainInfo>
        {!hasAvailableTickets ? (
          <NoTicketsInfo />
        ) : description || conditions ? (
          <SecondaryInfo>
            {description && (
              <SecondaryInfoBlock>
                <Label>{i18n.gettext('Description')}</Label>
                <InfoText dangerouslySetInnerHTML={{ __html: description }} />
              </SecondaryInfoBlock>
            )}
            {conditions && (
              <SecondaryInfoBlock>
                <Label>{i18n.gettext('Conditions')}</Label>
                <InfoText dangerouslySetInnerHTML={{ __html: conditions }} />
              </SecondaryInfoBlock>
            )}
          </SecondaryInfo>
        ) : null}
      </InfoBlockContainer>
    </Container>
  );
});

export default InfoBlock;
